// @flow
import * as React from 'react';
import styled from 'styled-components';
import {Slide} from 'components/Animation';
import ButtonNextPage from 'components/ButtonNextPage';

import {useImage} from 'components/Image';
import {LayoutCenterMiddle, useLayoutState} from 'components/Layout';
import {useLocalized, Paragraph} from 'components/Localized';
import {GuideMessageInline} from 'components/GuideMessageCenter';
import GuideMessage from './GuideMessage';
import GuideStep from '../GuideStep';
import {Disclaimer} from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';
import {getLocalizedFileName} from 'components/LocalizedImage';
import SoundToggleButton from 'components/SoundToggleButton';
import {useHistory,  useLocation} from 'react-router-dom';

type PropsChapter = {
  onNext: () => void,
  onOpenModalIndex: (boolean) => void,
  onCloseModalIndex: () => void,
  openModal: boolean,
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


export default function Chapter1(props: PropsChapter): React.Element<any> {
  const history = useHistory();
  const goto = useQuery().get("guide");
  const gotoNo = React.useMemo(() => goto != null ? parseInt(goto) : null, [goto])  || 0;

  const localized = useLocalized();
  const [page, setPage] = React.useState(gotoNo);
  const [disclaimerOpened, setDisclaimerOpened] = React.useState(false);
  //console.log("Chapter1, page=", page);
  
  //console.log("guide:gotoNo=", gotoNo, "page=", page);
  React.useEffect(() => {
    if (gotoNo != null) {
      history.replace(history.location.pathname);
    }
    //eslint-disable-next-line
    if (gotoNo != 0 && gotoNo != null && gotoNo != page) {
      setTimeout(()=>{
        
      }, 100);
      setPage(gotoNo);
      
    }
    
  }, [gotoNo, page, history]);
  // if (gotoNo != null) {
  //   //setPage(gotoNo);
  // }
  // if (gotoNo != null && gotoNo != page) {
  //   setPage(gotoNo);
  // }

  React.useEffect(()=>{
    if (page === 0) {
      
    }
    if (page >= 2) {
      AudioUtils.playBGM_racing();
    } else {
      AudioUtils.playBGM_UI();
    }

    
    return ()=>{
    };
  }, [page]);

  React.useEffect(()=>{
    if (page === 0) {
      window.tagManager.drivingZoneCourseAIntroPage();
    }
    if (page === 1) {
      window.tagManager.drivingZoneCourseAStepInfoPage();
    }
    if (page === 2) {
      window.tagManager.drivingZoneCourseACollectGTItemsPage();
    }

    
  },[page]);


  let disclaimerKey;
  if (page === 0) {
    disclaimerKey = "disclaimer_driving";
  } else if (page === 1) {
    disclaimerKey = "disclaimer_driving";
  } else {
    disclaimerKey = "disclaimer_driving";
  }
  //console.log("Chapter1:page=", page);

  const guidePopups = React.useMemo<Array<PropsGuidePopupCard>>(
    () => [
      {
        image: getLocalizedFileName('./driving-zone/img-guide-gt-popup-1.png'),
      },
      {
        image: getLocalizedFileName('./driving-zone/img-guide-gt-popup-2.png'),
      },
      {
        image: getLocalizedFileName('./driving-zone/img-guide-gt-popup-3.png'),
      },
      {
        image: getLocalizedFileName('./driving-zone/img-guide-gt-popup-4.png'),
      },
      {
        image: getLocalizedFileName('./driving-zone/img-guide-gt-popup-5.png'),
        disclaimerPopupKey: localized.disclaimer_eco_popup,
        onClick: ()=>{
          setDisclaimerOpened(true);
        }
      },
    ],
    [localized]
  );

  const handleNext = React.useCallback(() => {
    let nextPage = page + 1;
    if (nextPage < 3) {
      if (nextPage === 1) {
        window.tagManager.introNextLinkClick();

      }
      setPage(nextPage);
    }
    else {
      props.onNext();
    }
  }, [page, props])

  const handleMoveTo = React.useCallback(
    (url: string) => {
      history.push(`/driving-zone/course-a/${url}`);
    },
    [history]
  );

  return (
    <Wrapper>
      <TouchArea isHidden={props.openModal} >
        <LayoutCenterMiddle>
          <GuideMessage in={page === 0} timeout={300} guide={localized.driving_a00_guide_001} paddingBottom={70} />
        </LayoutCenterMiddle>
        {page === 1 &&
          <GuideStep show={page === 1}
            title={[
              "driving_a00_guide_210426_001",
              "driving_a00_guide_210426_002"
            ]}
            step={[
              "driving_a00_guide1_011",
              "driving_a00_guide1_012",
              "driving_a00_guide1_013",
            ]}
            stepTitle={[
              "driving_a00_guide1_extra_001",
              "driving_a00_guide1_extra_002",
              "driving_a00_guide1_extra_003"
            ]}
            images={[
              "./driving-zone/a/img-step-a-bg-1.jpg",
              "./driving-zone/a/img-step-a-bg-2.jpg",
              "./driving-zone/a/img-step-a-bg-3.jpg"
            ]}
            onStep={[
              ()=>{window.tagManager.stepInfoStep1ClickLinkClick();handleNext();},
              ()=>{window.tagManager.stepInfoStep2ClickLinkClick();handleMoveTo("gtmode-guide");},
              ()=>{window.tagManager.stepInfoStep3ClickLinkClick();handleMoveTo("acceleration");}
            ]}/>
        }
        <LayoutCenterMiddle>
          <DivColumn>
            <GuideMessageInline show={page === 2} >
              <Paragraph textKey="driving_a00_guide_002" />
              <Paragraph textKey="driving_a00_guide_003" />
            </GuideMessageInline>
            <GuideImageContainer>
              {guidePopups.map((value, idx) => (
                <GuidePopupCard {...value} key={idx} delay={idx * 300} show={page === 2} />
              ))}
              <GuideImageSpace />
            </GuideImageContainer>
          </DivColumn>
        </LayoutCenterMiddle>
      </TouchArea>
      {props.openModal !== true && <ButtonNextPage onNext={handleNext} title={localized.button_next} />}
      <SoundToggleButton />
      { disclaimerKey != null && !disclaimerOpened && 
      <Disclaimer textKey={disclaimerKey} onPopupClose={()=>{
        setDisclaimerOpened(false);
      }} />
      }
      { disclaimerOpened && 
      <Disclaimer popupTextKey="disclaimer_eco_popup" onPopupClose={()=>{
        setDisclaimerOpened(false);
      }} />
      }

      
    </Wrapper>
  );
}
type PropsGuidePopupCard = {
  image: string,
  delay?: number,
  show?: boolean,
  disclaimerPopupKey?: string,
  onClick?: () => void
};

function GuidePopupCard(props: PropsGuidePopupCard) {
  const layoutState = useLayoutState();
  const {delay, show} = props;
  
  const images = useImage(props.image);
  //const DisclaimerPopupButton = 
  
  const onClick = props.onClick;

  return (
    <Slide
      in={show}
      direction="left"
      timeout={300}
      delay={delay}
      defaultStyle={{
        transitionDelay: delay ?? 0,
        opacity: 0.2,
      }}
      transitionStyles={{
        entering: {opacity: 1},
        entered: {opacity: 1},
        exiting: {opacity: 0.2},
        exited: {opacity: 0.2},
      }}
      scale={layoutState.scale}
      >
      <GuideImage {...images} onClick={onClick}>
      </GuideImage>
    </Slide>
  );
}

const Wrapper = styled.div`
  width:100%;
  height: 100%;
`;

const TouchArea = styled.div`
  width: 100%;
  height: 100%;
  opacity: ${props => props.isHidden ? 0 : 1};
  text-align: center;
`;

const DivColumn = styled.div`
  padding-bottom: ${(props) => (props.theme.layout.mobile ? 45 : 129)}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GuideImageContainer = styled.div`
  padding-top: 36px;
  display: flex;
`;

const GuideImage = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 140 : 280)}px;
  height: ${(props) => (props.theme.layout.mobile ? 155 : 310)}px;
  margin-right: ${(props) => (props.theme.layout.mobile ? -25 : -50)}px;
  display: inline-block;
  background-image: url(${(props) => props.theme.layout.mobile ? props.imageMobile : props.imageDesktop});
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  pointer-events: auto;
`;

const GuideImageSpace = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 25 : 50)}px;
  height: 155px;
  display: inline-block;
`;
